<template>
  <div id="navigation-logo-wrapper">
    <router-link
      to="/"
      title="Главная"
      v-on:click.native="$emit('hide-main-navigation')"
    >
      <svg-sprite-icon
        class="logo"
        v-bind:src="'logo-mini'"
      ></svg-sprite-icon>
    </router-link>
  </div>
</template>

<script>
import SvgSpriteIcon from '../../utils/SvgSpriteIcon'

export default {
  name: 'NavigationMainLogoButton',
  components: { SvgSpriteIcon }
}
</script>

<style lang="scss">
  #navigation-logo-wrapper {
    display: inline-block;
    height: 100%;
    vertical-align: top;
    & > a {
      line-height: $the-header-main-height;
      padding: 0 20px;
      & > .logo {
        fill-rule: evenodd;
        height: 30px;
        width: 30px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-header/navigation-main/NavigationMainLogoButton.vue